module.exports = __webpack_public_path__ + "img/If_there's_liquid_in_the_tube_due_to_overfilling....08988410.png";